import SingleChoice from './containers/SingleChoiceContainer';
import { getPrice, getSelected } from './utils/selection';
export const singleChoice = {
  getPrice,
  getSelected
};
export default SingleChoice;
//# sourceMappingURL=index.js.map